<template>
	<div>
		<CustomSelector3
			:value="returnLanguage"
			:options="languages"
			:showIcon="true"
			@input="handleInput"
			class="notranslate"
			translate="no"
		/>
	</div>
</template>

<script setup>
import CustomSelector3 from '@/components/CustomSelector3'
import store from '@/store'
import axios from 'axios'
import {
	LangsLTD,
	LangsLATAM,
	LangsJAPAN,
	LangsMENA,
} from '@/utils/to_hidde.js'
import router from '../router'
import { ref, computed, watch, onMounted } from 'vue'

const entity = localStorage.getItem('userEntity')
const language = ref(router.currentRoute.value.params.locale || 'en')
const languages = ref([
	{
		text: 'ENG',
		value: 'en',
		icon: '/assets/images/flags/gb.svg',
	},
	{
		text: 'ESP',
		value: 'es',
		icon: '/assets/images/flags/es.svg',
	},
	{
		text: 'POR',
		value: 'pt',
		icon: '/assets/images/flags/pt.svg',
	},
	{
		text: '現代語',
		value: 'jp',
		icon: '/assets/images/flags/jp.svg',
	},
	{
		text: 'عربي',
		value: 'ar',
		icon: '/assets/images/flags/ar.svg',
	},
	{
		text: '中国人',
		value: 'zh',
		icon: '/assets/images/flags/ch.svg',
	},
	{
		text: '한국인',
		value: 'ko',
		icon: '/assets/images/flags/kr.svg',
	},
])

const returnLanguage = computed(() => language.value)

const handleInput = (valueEmitted) => {
	language.value = valueEmitted

	const currentRoute = router.currentRoute.value.fullPath
	const currentLocale = router.currentRoute.value.params.locale
	const newPath = currentRoute.replace(`/${currentLocale}`, '')
	const newRoute = `/${language.value}${newPath}`

	window.location.href = newRoute
}

const updatelanguage = async () => {
	localStorage.setItem('language', language.value)

	let preferences = store.state.preferences

	if (preferences) {
		const _headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: 'Bearer ' + store.state.token,
		}
		const _url =
			process.env.VUE_APP_CABINET_V2_API_HOST_PREFERENCES + '/preferences/user'
		const _body = {
			dashboardLanguage: language.value,
			emailsLanguage: language.value,
		}

		try {
			const result = await axios({
				method: 'post',
				url: _url,
				data: _body,
				headers: _headers,
			})

			console.log(result.data)
		} catch (error) {
			console.error(error)
		}
	}
}

watch(language, () => {
	updatelanguage()
})

onMounted(() => {
	const urlLocale = router.currentRoute.value.params.locale
	const localStorageLocale = localStorage.getItem('language')

	if (urlLocale !== localStorageLocale) {
		handleInput(urlLocale)
		updatelanguage()
	}
})
</script>
